module.exports = __webpack_public_path__ + "static/media/HCMM604.5619eac2.jpg";